export default __webpack_public_path__ + "static/pagination.alpinamed-8815e0404db4409cc3048361b96d79ba.png";